export default {

  calculateValues(data) {
    return env.API.post('/user/drainage/getDrainageRealTime', { singleNutrient : data});
  },

  saveDrainage(data) {
    return env.API.post('/user/drainage/create', data);
  },

  updateDrainage(data) {
    return env.API.post('/user/drainage/edit', data);
  },

  deleteDrainage(drainageId) {
    return env.API.post('/user/drainage/delete', drainageId);
  },

  getUserDrainages(filter) {
    return env.API.post('/user/drainage/getAll', filter)
  },
  selectSingleDrainage(drainageId) {
    return env.API.post('/user/drainage/select', drainageId)
  },
  InsertDrainageData(data) {
    return env.API.post('/user/drainage/insertDrainageData', data)
  },

  removeDrainageFromStep(data) {
    return env.API.post('/user/drainage/removeDrainageFromStep', data)
  },

  findByStep(stepId) {
    return env.API.post('/user/drainage/findByStep', stepId)
  },
  getProgramsByCrop(data) {
    return env.API.post('/user/drainage/getProgramsByCrop', data)
  }
}
